export const toSafeNumber = (v) => {
  const n = Number(String(v ?? "").replace(/,/g, "").trim());
  return Number.isFinite(n) ? n : 0;
};

export const normalizeOrderForPrint = (order, totalItemsValue, productsMap = {}) => {
  const od = order || {};

  const itemsList =
    od.order_items ||
    od.items ||
    od.orderItems ||
    [];

  // ✅ normalize customer
  const customer = {
    ...(od.customer || {}),
    name: od?.customer?.name || od.customer_name || "",
    phone: od?.customer?.phone || od.customer_phone || "",
    email: od?.customer?.email || "",
    address: od?.customer?.address || od.customer_address || "",
    address2: od?.customer?.address2 || od.customer_address2 || "",
    address3: od?.customer?.address3 || od.customer_address3 || "",
    phone2: od?.customer?.phone2 || od.customer_phone2 || "",
    phone3: od?.customer?.phone3 || od.customer_phone3 || "",
  };

  // ✅ normalize table data (name + number) for print consistency
  const tableNumber =
    od?.table?.number ||
    od?.table_number ||
    od?.table_no ||
    od?.table_num ||
    od?.table_id ||
    "";

  const tableName =
    od?.table?.name ||
    od?.table_name ||
    (tableNumber ? `طاولة ${tableNumber}` : "");

  const table = {
    ...(od?.table || {}),
    name: tableName,
    number: tableNumber,
  };

  // ✅ normalize captain + invoice creator names for print
  const captainOrderName =
    od?.captain_order?.name ||
    od?.captain?.name ||
    od?.captain_order_name ||
    (od?.captain_order_id ? `#${od.captain_order_id}` : "");

  const invoiceCreatedByName =
    od?.invoice_created_by_name ||
    od?.created_by_name ||
    od?.created_by ||
    od?.user?.name ||
    od?.user_name ||
    "";

  // ✅ enrich items with product_name
  const normalizedItems = (Array.isArray(itemsList) ? itemsList : []).map((it) => {
    const isCustomDrink = !it?.product && it?.drinks;

    // ✅ المنتج من الخريطة لو مفيش product object
    const productFromMap = it?.product_id ? productsMap?.[it.product_id] : null;

    const product_name =
      it?.product_name ||
      it?.product?.name ||
      (productFromMap?.name || "") ||
      (isCustomDrink
        ? (it?.drinks?.drink_name || it?.drinks?.name || `مخصص #${it?.drink_id || it?.id}`)
        : (it?.product_id ? `من منيو #${it.product_id}` : `صنف #${it?.id}`));

    const quantity = toSafeNumber(it?.quantity || 0);

    const price =
      toSafeNumber(it?.price) ||
      toSafeNumber(it?.unit_price) ||
      (toSafeNumber(it?.total) && quantity ? toSafeNumber(it.total) / quantity : 0);

    const total = toSafeNumber(it?.total) || price * quantity;

    return {
      ...it,
      product_name,
      quantity,
      price,
      total,
    };
  });

  const subTotal =
    toSafeNumber(totalItemsValue) ||
    normalizedItems.reduce((sum, it) => sum + toSafeNumber(it.total), 0) ||
    toSafeNumber(od.total);

  // ✅ مهم: items و order_items نفس الـ array
  return {
    ...od,
    customer,
    table,
    table_number: tableNumber,
    captain_order_name: captainOrderName,
    invoice_created_by_name: invoiceCreatedByName,
    items: normalizedItems,
    order_items: normalizedItems,
    sub_total: subTotal,
  };
};